import { findNodePath, findNode } from "@/utils/getTreeNodes.js";
import {Local} from "@/utils/storage";
import { handleUserMenuAuth } from '@/utils/auth';

export default ({
  name: 'SingleronMobileMenus',
  components: {
	},
  data() {
    return {
      isCollapse: true,
      menusList: [],
      acountList: [],
    };
  },
  props: {
  },
  watch: {
  },
  mounted(){
    this.initData();
  },
  methods:{
    // 处理菜单权限
    handleAuth() {
      const userInfo = Local.get('user_info');
      if(!userInfo) {return;}
      const menu =  userInfo.privileges;
      handleUserMenuAuth(menu);
      this.menusList = this.$store.state.routesList.routesList;
      this.acountList = this.menusList[this.menusList.length - 1].children;
      this.$emit('sendAcountList', this.acountList);
      this.menusList = this.menusList.filter(item => item.name !== 'My account');
    },
    

    handleSelect(val) {
      this.handleRoute('id',val);
      this.findFatherNode('id',val);
      this.$emit('clearGeneCellStudyData');
    },

    // 处理路由跳转
    handleRoute(key,val) {
      const targetNode = findNode(key, this.menusList, val);
      if(targetNode && targetNode.disabled) {
        return;
      }
      if(targetNode && targetNode.routePath) {
        this.$router.push({
          path: targetNode.routePath,
          query: targetNode.query? targetNode.query : {}});
          this.$emit('sendRoute');
      }
    },

    // 查询当前节点的顶级父节点
    findFatherNode(key, val) {
      const nodeArray = findNodePath(key, this.menusList, val);
      if(!nodeArray.length) {
        return;
      }
      const firstNode = nodeArray[0];
      this.menusList.forEach(item => item.active = false);
      this.menusList.find(item => item.id === firstNode.id).active = true;
    },

    initData() {
      this.handleAuth();
    },
  },
});